import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';
import { EventIdRegistryService } from 'src/app/shared/services/event-id-registry.service';
import { BLOCKLY_COLORS } from './blocky-types.types';

let _registered = false;
let _registryService: EventIdRegistryService;

/**
 * Registriert den EVENT_ID_DROPDOWN-Block.
 * Dieser Block zeigt ein dynamisches Dropdown mit allen vergebenen Event-IDs
 * aus EVENTS_ON_NEW-Blöcken (editor-übergreifend).
 */
export function registerEventIdDropdownBlock(registry: EventIdRegistryService): void {
    if (_registered) return;
    _registered = true;
    _registryService = registry;

    Blockly.defineBlocksWithJsonArray([
        {
            type: 'EVENT_ID_DROPDOWN',
            message0: '🏷️ %1',
            args0: [
                {
                    type: 'field_dropdown',
                    name: 'EVENT_ID',
                    options: function () {
                        return _registryService.getDropdownOptions();
                    },
                }
            ],
            output: 'String',
            colour: BLOCKLY_COLORS.EVENTS_LIGHT,
            tooltip: 'Wähle eine vergebene Event-ID aus.\n\n🆔 EVENT_ID_DROPDOWN',
        }
    ]);

    javascriptGenerator.forBlock['EVENT_ID_DROPDOWN'] = (block) => {
        const eventId = block.getFieldValue('EVENT_ID');
        return [`"${eventId}"`, 0];
    };
}
